import React, { useEffect, useState } from "react";
import { Tag } from "antd";
import { CheckCircleFilled, ClockCircleOutlined, CloseCircleOutlined, FlagOutlined, ShopOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { CustomerReview, ReviewStatus, reviewStates, reviewAssetUrl } from "../reviewWorkspaceModel";

export const reviewDate = (value: string) => dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY") : "Date indisponible";
export function ReviewState({ status }: { status: ReviewStatus }) {
  const state = reviewStates[status];
  const icon = status === "approved" ? <CheckCircleFilled /> : status === "pending" ? <ClockCircleOutlined /> : status === "spam" ? <FlagOutlined /> : <CloseCircleOutlined />;
  return <Tag color={state.tone} icon={icon}>{state.label}</Tag>;
}
export function ReviewProduct({ review }: { review: CustomerReview }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [review.product_image]);
  const image = reviewAssetUrl(review.product_image);
  return <span className="review-product"><span className="review-product-image">{image && !failed ? <img src={image} alt={review.product_name} onError={() => setFailed(true)} /> : <ShopOutlined aria-label="Photo indisponible" />}</span><span>{review.product_name}</span></span>;
}
export function VerifiedPurchase({ verified }: { verified: boolean }) { return verified ? <span className="review-verified"><CheckCircleFilled /> Achat vérifié</span> : null; }
export const initials = (name: string) => name.split(/\s+/).filter(Boolean).slice(0, 2).map((word) => word[0]).join("").toUpperCase();
